var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.15 9.966-2.437-2.37-1.046 1.018L6.15 12l7.184-6.983L12.287 4z"
})));
export { SvgCheckedIcon as ReactComponent };
export default __webpack_public_path__ + "e70bc62c1de890b0a652dda26c3f5ae3.svg";